// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import router from 'components/Router';
import {
  getSystemFields,
  checkUnidentifiedCategories,
  saveBulkCostCodes,
  checkDefaultCategory,
} from '../services/cost_code';
import costCodeImportActions, { Types } from '../actions/cost_code_import';
import { successToast } from 'utils/toastHandler';
import { errorToast } from 'utils/toastHandler';

function* getSystemFieldsRequest() {
  try {
    const response = yield call(getSystemFields);
    yield put(costCodeImportActions.getSystemFieldsSuccess(response.data));
  } catch (error) {
    yield put(costCodeImportActions.getSystemFieldsFailure());
  }
}

function* checkUnidentifiedCategoriesRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(checkUnidentifiedCategories, payload);
    yield put(
      costCodeImportActions.checkUnidentifiedCategoriesSuccess({
        data: response.data,
      }),
    );

    yield put(costCodeImportActions.setStep({ step: 3 }));
  } catch (error) {
    yield put(costCodeImportActions.checkUnidentifiedCategoriesFailure());
  }
}

function* saveBulkCostCodesRequest(action) {
  try {
    const { payload } = action;
    yield call(saveBulkCostCodes, payload);
    yield put(costCodeImportActions.saveBulkCostCodesSuccess());
    router.navigate(`/settings/accounting-code`);
    successToast('Accounting Code imported successfully!');
  } catch (error) {
    errorToast(
      error?.response?.data?.error || 'Error Importing Accounting Code',
    );
    yield put(costCodeImportActions.saveBulkCostCodesFailure());
  }
}

function* checkDefaultCategoryRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(checkDefaultCategory, payload);
    yield put(costCodeImportActions.checkDefaultCategorySuccess(response.data));
  } catch (error) {
    yield put(costCodeImportActions.checkDefaultCategoryFailure());
  }
}

function* costCodeWatcher() {
  yield takeLatest(Types.GET_SYSTEM_FIELDS_REQUEST, getSystemFieldsRequest);
  yield takeLatest(
    Types.CHECK_UNIDENTIFIED_CATEGORIES_REQUEST,
    checkUnidentifiedCategoriesRequest,
  );
  yield takeLatest(
    Types.SAVE_BULK_COST_CODES_REQUEST,
    saveBulkCostCodesRequest,
  );

  yield takeLatest(
    Types.CHECK_DEFAULT_CATEGORY_REQUEST,
    checkDefaultCategoryRequest,
  );
}

export default costCodeWatcher;
